/* eslint-disable @typescript-eslint/camelcase */

import { QueryParamsEntitiesV3 } from "@/domain/entities/MainApp";

export class HandoverV2DetailParams {
  sttNo = "";
  bagNo = "";
  partnerCode = "";
  manifestKey = "";
  isIncludeUnavailableVendor = true;
  constructor(fields?: Partial<HandoverV2DetailParams>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }
}
